export default __webpack_public_path__ + "static/AMA20 Finalist Medal_Brokerage of the Year - Diversification-3be944736b4cfc053537585e0f57b0f2.png";